import styles from "./ConsultingDetail.module.css";
import SubPageTop from "../../components/SubPageTop";
import ScrollReveal from "../../components/Ui/ScrollReveal";
import { FiPackage, FiLayers, FiEye } from "react-icons/fi";
import React from "react";
const steps = [
  {
    icon: <FiPackage size={32} color="#ff5670" />,
    title: "제품개발",
    desc: [
      "영메이크업, 헤어, 패션 브랜드의 특징에 따라 출시 제품색 분석",
      "제품색 테스트, 피드백 과정을 거쳐 마켓컬러 선정",
    ],
  },
  {
    icon: <FiLayers size={32} color="#ff5670" />,
    title: "배색제안",
    desc: [
      "제품을 이용한 스타일링 연출이 가능한 배색 선정",
      "브랜드 컬러와 연동 가능하도록 세일즈 배색 제안"
    ],
  },
  {
    icon: <FiEye size={32} color="#ff5670" />,
    title: "컬러감리",
    desc: [
      "컬러 표준을 체크하여 브랜드 에서 원하는 컬러 실제 추출",
      "컬러의 강약을 조절하여 쉽게 생산 가능한 컬러코드 결과 제출"
    ],
  },
];
function EnterpriseBeauty() {
  return (
    <div className={styles.consultingDetail}>
      <SubPageTop title="Consulting" />
      <div className={styles.consultingDetailContent}>
        <ScrollReveal>
          <section className={styles.section01}>
          <div className={styles.imgbox}>
            <img
              src="/image/consulting-detail-section01-05.png"
              alt="컬러 이미지"
            />
          </div>
          <div className={styles.infoBox}>
            <div className={styles.infoHeader}>
              <p className={styles.subtitle}>Color Consulting</p>
              <p className={styles.koTitle}>뷰티 컬러 컨설팅</p>
            </div>
            <div className={styles.infoDetail}>
              <div className={styles.infoDesc}>
                뷰티 컬러디자인은,
                <br />
                고감도의 색채감각과 22가지 이미지 스케일 분석을 활용하여
                차별화된 색채를 선정합니다.
              </div>
              <ul className={styles.infoList}>
                <li>
                  <span className={styles.pointcolor}>·</span>
                  <span>
                    트렌드 컬러 / 마켓컬러 / 세일즈 흐름을 파악하여 제품색을
                    분석하고 색채 영역을 제안
                  </span>
                </li>
                <li>
                  <span className={styles.pointcolor}>·</span>
                  <span>
                    메이크업, 헤어, 패션 등 브랜드가 추구하는 방향과 주 타겟층을
                    고려한 색채 팔레트 구성
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </section>
        </ScrollReveal>
        <ScrollReveal>
          <section className={styles.section02}>
          <div className={styles.titleWrap}>
            <p className={styles.programSubtitle}>process</p>
            <h2 className={styles.title}>컨설팅 프로세스</h2>
          </div>
          <div className={styles.line}></div>
          <div className={styles.steps}>
            {steps.map((step, i) => (
              <React.Fragment key={i}>
                <div className={styles.step}>
                  <div className={styles.iconWrap}>{step.icon}</div>
                  <div className={styles.textWrap}>
                    <div className={styles.stepTitle}>{step.title}</div>
                    <div className={styles.stepDesc}>
                      <div className={styles.stepDesc}>
                        {Array.isArray(step.desc) ? (
                          <ul>
                            {step.desc.map((text, idx) => (
                              <li key={idx}>{text}</li>
                            ))}
                          </ul>
                        ) : (
                          step.desc
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {i < steps.length - 1 && (
                  <div className={styles.arrowWrap}>
                    <img
                      src="/image/arrow_right.png"
                      alt="arrow_right"
                      className={styles.arrow}
                    />
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
        </section>
        </ScrollReveal>
      </div>
    </div>
  );
}

export default EnterpriseBeauty;
